module.exports = __webpack_public_path__ + "static/media/add_ic.4709b370.svg";